import $ from 'jquery'

global.$ = $

//require('slick-carousel/slick/slick.min')
